// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__rr1Br","itemsWrapper":"Table_itemsWrapper__iAjWy"};